<template>
  <div class="news-list-box">
    <div class="news-banner-Box">
      <img src="../../../assets/img/home/newsBanner.jpg" alt="">
      <div class="news-text">
        <h1>资讯动态</h1>
        <p>了解最新行业资讯，聚焦行业风向标</p>
      </div>
    </div>
    <div class="news-list-content">  
      <div class="news-content-box">
        <div class="news-list">
          <router-link class="item" v-for="(item,index) in newsList" :key="index" :to="{path:'/home/news/info',query:{newsId:item.id}}">
            <dl class="dl">
              <dt class="dt">
                <img :src="item.imageUrl" width="100%" height="100%" alt="">
              </dt>
              <dd class="dd">
                <h3 class="title">{{item.title}}</h3>
                <p class="text ellipsis5">{{item.description}}</p>
                <p class="date">{{item.publishTime | parseTime()}}</p>
              </dd>
            </dl>
          </router-link>
        </div>
        <div class="paginationBox" v-if="newsList.length">
          <el-pagination
            background
            class="pagination-box"
            @current-change="currentChange"
            :page-size="pageInfo.perPage"
            :total="pageInfo.total"
            layout="prev, pager, next"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  created() {
    // this.queryBannerList(); //获取banner
    this.queryList(); //获取APP应用list
  },
  data() {
    return {
      swiperList: [], //banner
      newsList: [],//资讯
      pageInfo:{
        total:99,
        page: 1,
        perPage: 6,
      },
    };
  },
  methods: {
    //获取banner
    queryBannerList() {
      this.$apis.newsSever.queryBannerList({
        type:2,
        num:4,
      }).then(res => {
        if (res.code == 0) {
          this.swiperList = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //获取资讯list
    queryList() {
      this.$apis.newsSever.queryNewsList({
        page: this.pageInfo.page,
        perPage: this.pageInfo.perPage,
      })
      .then((res) => {
        if (res.code == 0) {
          this.newsList = res.data.data;
          this.pageInfo.total = res.data.total;
        } else {
          this.newsList = [];
          this.pageInfo.total = 0;
          this.$message.error(res.message);
        }
      });
    },
    //翻页
    currentChange(val) {
      this.pageInfo.page = val;
      this.queryList();
    },
  },
};
</script>

<style scoped lang="scss">
.news-list-box {
  padding-bottom: 32px;
   position: relative;
  .news-banner-Box{
    overflow: hidden;
    width: 100%;
   
    img{
      vertical-align: top;
      width: 100%;
    }
    .news-text{
      width: 1200px;
      position: absolute;
      z-index: 9;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      padding-top: 172px;
      h1{
        font-size: 64px;
        font-weight: bold;
        color: #333333;
        line-height: 75px;
      }
      p{
        margin-top: 20px;
        color: #666;
        font-size: 24px;
      }
    }
  }
  .news-list-content {
    width: 100%;
    padding: 20px;
    background: #fff;
    .news-content-box{
      width: 1200px;
      margin: 0 auto;
      .news-list{
        .item{
          display: block;
          padding: 35px 0;
          border-bottom:1px solid #DFDFDF;
          cursor: pointer; 
          .dl{
            display: flex;
            .dt{
              margin-right: 22px;
              width: 240px;
              height: 180px;
            }
            .dd{
              flex: 1;
              width: calc(100% - 234px);
              display: flex;
              flex-wrap: wrap;
              align-content: space-between;
              .title{
                font-size: 20px;
                font-weight: bold;
                color: #333;
              }
              .text{
                width: 100%;
                min-height: 100px;
                line-height: 24px;
                font-size: 16px;
                color: #666;
              }
              .date{
                font-size: 15px;
                color: #999;
              }
            }
          }
        }
      }
      .paginationBox{
        margin-top: 30px;
        text-align: center;
      }
    }
  }
}
</style>  

